import { GetImpersonateCollaboratorsResponse } from "../../../types/api/collaborators.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CollaboratorsImpersonateService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetImpersonateCollaboratorsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<GetImpersonateCollaboratorsResponse>(
      `v1/impersonate/collaborators?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );

    return response;
  },
  async startImpersonate(collaboratorEmail: string): Promise<void> {
    await httpClient.get<void>(`v1/impersonate/start/${collaboratorEmail}`);
  },
  async endImpersonate(): Promise<void> {
    await httpClient.get<void>("v1/impersonate/end");
  },
};

export default CollaboratorsImpersonateService;
